module.exports = __webpack_public_path__ + "static/TTNormsPro-Light-4b29b031b600594220730aae4158ec11.woff2";